<app-closeable-dialog-title
  (maximizedChanged)="toggleMaximize($event)"
  [title]="data.title">
</app-closeable-dialog-title>


<div mat-dialog-content class="maximize">
  <markdown
    [src]="data.path">
  </markdown>
</div>
